import React, { useState, useEffect } from "react";

export default function DecimalToBinaryTyping() {
  const [minRange, setMinRange] = useState(1);
  const [maxRange, setMaxRange] = useState(10);
  const [currentDecimal, setCurrentDecimal] = useState(0);
  const [userInput, setUserInput] = useState("");
  const [feedback, setFeedback] = useState("");
  const [inputStyle, setInputStyle] = useState({});

  // Generate random decimal
  const generateDecimal = () => {
    const randomVal =
      Math.floor(Math.random() * (maxRange - minRange + 1)) + minRange;
    setCurrentDecimal(randomVal);
    setUserInput("");
    setFeedback("");
    setInputStyle({});
  };

  // Initialize first question
  useEffect(() => {
    generateDecimal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minRange, maxRange]);

  // Check answer
  const checkAnswer = () => {
    const correctBinary = currentDecimal.toString(2);
    if (userInput.trim() === correctBinary) {
      setFeedback("Correct! 🎉");
      setInputStyle({
        borderColor: "green",
        backgroundColor: "#d4ffd4",
      });
      setTimeout(generateDecimal, 1000);
    } else {
      setFeedback("Incorrect! Try again.");
      setInputStyle({
        borderColor: "red",
        backgroundColor: "#ffd4d4",
      });
    }
  };

  // Handle range change
  const handleRangeChange = (e) => {
    const [min, max] = e.target.value.split("-").map(Number);
    setMinRange(min);
    setMaxRange(max);
  };

  // Inline styles
  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', Arial",
      background: "linear-gradient(to bottom, #f0f8ff, #d4f1f9)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "30px",
      minHeight: "100vh",
    },
    card: {
      background: "#fff",
      padding: "25px 35px",
      borderRadius: "15px",
      boxShadow: "2px 2px 12px rgba(0,0,0,0.2)",
      marginBottom: "20px",
      textAlign: "center",
      width: "400px",
    },
    select: {
      padding: "10px 15px",
      fontSize: "16px",
      borderRadius: "8px",
      border: "2px solid #ccc",
      marginTop: "10px",
    },
    input: {
      padding: "10px 15px",
      fontSize: "16px",
      borderRadius: "8px",
      border: "2px solid #ccc",
      marginTop: "10px",
      width: "100%",
    },
    button: {
      padding: "10px 15px",
      fontSize: "16px",
      borderRadius: "8px",
      marginTop: "10px",
      background: "#87ceeb",
      color: "#fff",
      border: "none",
      cursor: "pointer",
    },
    feedback: {
      marginTop: "15px",
      fontWeight: "bold",
      fontSize: "18px",
    },
  };

  return (
    <div style={styles.body}>
      <h2 style={{ marginBottom: "20px" }}>Decimal to Binary Practice</h2>

      <div style={styles.card}>
        <label htmlFor="rangeSelect">Select Decimal Range:</label>
        <select id="rangeSelect" onChange={handleRangeChange} style={styles.select}>
          <option value="1-10">1–10</option>
          <option value="10-20">10–20</option>
          <option value="20-30">20–30</option>
          <option value="30-50">30–50</option>
        </select>
      </div>

      <div style={styles.card}>
        <div style={{ fontSize: "24px", marginBottom: "15px" }}>
          Decimal: {currentDecimal}
        </div>
        <input
          type="text"
          placeholder="Enter binary number"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          style={{ ...styles.input, ...inputStyle }}
        />
        <button onClick={checkAnswer} style={styles.button}>
          Check
        </button>
        <div
          style={{
            ...styles.feedback,
            color: feedback === "Correct! 🎉" ? "green" : "red",
          }}
        >
          {feedback}
        </div>
      </div>
    </div>
  );
}
